export const Projects = [
  'CSS Art',
  'Generative Art',
  'Writing',
  'Front-End',
  'Doodles'
]

export const Socials = [
  {
    name: 'CodePen',
    description: 'CSS Art & Generative Art',
    link: 'https://codepen.io/poulamic'
  },
  {
    name: 'Medium',
    description: 'Writings on Design',
    link: 'https://poulamic.medium.com/'
  },
  {
    name: 'Instagram',
    description: 'Doodles',
    link: 'https://www.instagram.com/lines_and_patterns/'
  },
  {
    name: 'Twitter',
    description: 'Infrequent updates on projects',
    link: 'https://twitter.com/poulamic_'
  },
  {
    name: 'Github',
    description: 'Learning Front End',
    link: 'https://github.com/poulamic?tab=repositories'
  },
  {
    name: 'Dev',
    description: 'Documenting learnings',
    link: 'https://dev.to/poulamic/'
  }
]

export const Blogs = [
  {
    name: 'Design principles to revisit for Voice UX',
    link:
      'https://uxdesign.cc/design-principles-to-revisit-for-voice-ux-design-5a8b6fd0e8ed',
    description: 'Application of UX principles in conversation design,'
  },
  {
    name: 'Intro to creating CSS Art',
    link: 'https://dev.to/poulamic/intro-to-creating-css-art-1ep5',
    description: "A beginner's guide to get started with CSS-Art"
  },
  {
    name: 'Diving deep into CSS Layouts',
    link: 'https://dev.to/poulamic/diving-deep-into-css-layouts-about-166n',
    description:
      'A very deep dive into the intricacies of CSS layout properties'
  }
]

export const CSSArtSamples = [
  {
    src: '/assets/images/projects/CSSArt/CSS_chai.webp',
    alt: 'CSS Art: Chai and Parle-G',
    caption: 'CSS Chai and Parle-G',
    link: 'https://codepen.io/poulamic/full/YzGqjRr',
    color: '#c0eeee'
  },
  {
    src: '/assets/images/projects/CSSArt/CSS_bookshelf.webp',
    alt: 'CSS Art: Single Div Bookshelf',
    caption: 'Single Div Bookshelf',
    link: 'https://codepen.io/poulamic/full/eYJWrNE',
    color: 'white'
  },
  {
    src: '/assets/images/projects/CSSArt/CSS_cupcakes.webp',
    alt: 'CSS Art: Cupcakes',
    caption: 'CSS Cupcakes',
    link: 'https://codepen.io/poulamic/full/mdPPqbx',
    color: 'white'
  }
]

export const mobileContentList = [
  {
    name: 'Home',
    comp: 'WebsiteLanding',
    route: 'home/WebsiteLanding'
  },

  {
    name: 'CSS Art',
    comp: 'CSSArt',
    route: 'projects/CSSArt'
  },
  {
    name: 'Generative Art',
    comp: 'GenerativeArt',
    route: 'projects/GenerativeArt'
  },
  {
    name: 'Writing',
    comp: 'Writing',
    route: 'projects/Writing'
  },
  {
    name: 'FrontEnd',
    comp: 'FrontEnd',
    route: 'projects/FrontEnd'
  },
  {
    name: 'Doodles',
    comp: 'Doodles',
    route: 'projects/Doodles'
  },
  {
    name: 'About Me',
    comp: 'AboutMe',
    route: 'home/AboutMe'
  }
]
